import React from "react"

import { Indent } from "src/uikit"

import * as S from "./styled"
import Headline from "./components/Headline"
import BgEl1 from "./assets/bg-elem-1.svg"
import BgEl2 from "./assets/bg-elem-2.svg"
import Form from "../Form"

const Banner = ({
  json,
  isSuccessBody = false,
  onSuccess,
  downloadAssetModalId,
}) => {
  if (isSuccessBody) {
    return (
      <S.Container style={{ overflowX: "hidden" }}>
        <div className="inner success-body">
          <div className="text">
            <Headline json={json} />
          </div>
          <BgEl2 className="bg-2" />
        </div>
      </S.Container>
    )
  }

  return (
    <S.Container>
      <Indent lg={80} md={80} sm={40} />
      <div className="inner">
        <div className="text-container">
          <Headline json={json} />
        </div>
        <div className="form-container">
          <Form
            modalType
            downloadAssetModalId={downloadAssetModalId}
            onSuccess={onSuccess}
          />
        </div>

        <BgEl1 className="bg-1" />
      </div>
    </S.Container>
  )
}

export default Banner
